import { axiosInstance } from './base'

export function setAuthSession (data) {
  localStorage.setItem('isAuthenticated', true)
  localStorage.setItem('authToken', data.access)
  localStorage.setItem('userType', data.user_type)
  localStorage.setItem('_id', data.user_id)
}

export function getAuthSession () {
  const authToken = localStorage.getItem('authToken')
  const isAuthenticated = localStorage.getItem('isAuthenticated')
  if (authToken && isAuthenticated) {
    return { authToken, isAuthenticated }
  } else {
    return {
      authToken: '',
      isAuthenticated: false
    }
  }
}

export function buyerLogin (data) {
  return axiosInstance.post('buyers-login/', data)
}

export function techProviderLogin (data) {
  return axiosInstance.post('tech-providers-login/', data)
}

export function logout () {
  localStorage.removeItem('isAuthenticated')
  localStorage.removeItem('authToken')
  localStorage.removeItem('userType')
  localStorage.removeItem('_id')
  localStorage.clear()
}

export function register (data) {
  return axiosInstance.post('register/', data)
}

export function forgotPassword (data) {
  return axiosInstance.post('reset-password/', data)
}

export function approveRegistration (email) {
  return axiosInstance.put(`approve-registration/${email}`)
}

export function resetPassword (userTypeKey, data) {
  return axiosInstance.put(`reset-password/${userTypeKey}/`, data)
}

export function validateResetPasswordUrl (userTypeKey) {
  return axiosInstance.get(`reset-password/${userTypeKey}/`)
}
